module.exports = __webpack_public_path__ + "static/media/po-undercarriage-6.e5a317c2.png";